// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************************************************************************
 * Copyright (C) 2017 TypeFox and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0
 ********************************************************************************/

.theia-file-icons-js {
  /*
    Here, the \`line-height\` ensures that FontAwesome and \`file-icons-js\` container has the same height.
    Ideally, it would be 1 em, but since we set the max height above (and other places too) with 0.8
    multiplier, we use 0.8 em here too.
     */
  line-height: 0.8em;
}

.theia-file-icons-js:before {
  font-size: calc(var(--theia-content-font-size) * 0.8);
}

.p-TabBar-tabIcon.theia-file-icons-js.file-icon {
  padding-left: 1px !important;
  padding-right: 3px !important;
}

.theia-file-icons-js.file-icon {
  min-width: var(--theia-icon-size);
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 2px;
  padding-right: 4px;
}

.default-folder-icon,
.default-file-icon {
  padding-right: 6px;
}

.fa-file:before,
.fa-folder:before,
.theia-file-icons-js:before {
  text-align: center;
  margin-right: 4px;
}

.theia-app-sides .theia-file-icons-js {
  max-height: none;
  line-height: inherit;
}

.theia-app-sides .theia-file-icons-js:before {
  font-size: var(--theia-private-sidebar-icon-size);
  margin-right: 0px;
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/node_modules/@theia/filesystem/src/browser/style/file-icons.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;iFAciF;;AAEjF;EACE;;;;MAII;EACJ,kBAAkB;AACpB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;EACjC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;;EAGE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,iDAAiD;EACjD,iBAAiB;AACnB","sourcesContent":["/********************************************************************************\n * Copyright (C) 2017 TypeFox and others.\n *\n * This program and the accompanying materials are made available under the\n * terms of the Eclipse Public License v. 2.0 which is available at\n * http://www.eclipse.org/legal/epl-2.0.\n *\n * This Source Code may also be made available under the following Secondary\n * Licenses when the conditions for such availability set forth in the Eclipse\n * Public License v. 2.0 are satisfied: GNU General Public License, version 2\n * with the GNU Classpath Exception which is available at\n * https://www.gnu.org/software/classpath/license.html.\n *\n * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0\n ********************************************************************************/\n\n.theia-file-icons-js {\n  /*\n    Here, the `line-height` ensures that FontAwesome and `file-icons-js` container has the same height.\n    Ideally, it would be 1 em, but since we set the max height above (and other places too) with 0.8\n    multiplier, we use 0.8 em here too.\n     */\n  line-height: 0.8em;\n}\n\n.theia-file-icons-js:before {\n  font-size: calc(var(--theia-content-font-size) * 0.8);\n}\n\n.p-TabBar-tabIcon.theia-file-icons-js.file-icon {\n  padding-left: 1px !important;\n  padding-right: 3px !important;\n}\n\n.theia-file-icons-js.file-icon {\n  min-width: var(--theia-icon-size);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-left: 2px;\n  padding-right: 4px;\n}\n\n.default-folder-icon,\n.default-file-icon {\n  padding-right: 6px;\n}\n\n.fa-file:before,\n.fa-folder:before,\n.theia-file-icons-js:before {\n  text-align: center;\n  margin-right: 4px;\n}\n\n.theia-app-sides .theia-file-icons-js {\n  max-height: none;\n  line-height: inherit;\n}\n\n.theia-app-sides .theia-file-icons-js:before {\n  font-size: var(--theia-private-sidebar-icon-size);\n  margin-right: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
